import { render, staticRenderFns } from "./test.vue?vue&type=template&id=f5e9fb8c&scoped=true&"
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"
import style0 from "./test.vue?vue&type=style&index=0&id=f5e9fb8c&scoped=true&lang=css&"
import style1 from "./test.vue?vue&type=style&index=1&id=f5e9fb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e9fb8c",
  null
  
)

export default component.exports